if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      constructor() {
        super();

        this.compatibleAccessoryScrollFrame = null;
        this.compatibleAccessoryStatusTimer = null;
        this.addEventListener(
          "click",
          this.onCompatibleAccessoryControl.bind(this),
        );
        this.addEventListener(
          "scroll",
          this.onCompatibleAccessoryScroll.bind(this),
          true,
        );
      }

      show(opener) {
        super.show(opener);

        requestAnimationFrame(() => {
          this.querySelectorAll("[data-ubpet-accessory-list]").forEach((list) =>
            this.updateCompatibleAccessoryControls(list),
          );
        });

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.showContent();
      }

      hide() {
        super.hide();

        clearTimeout(this.compatibleAccessoryStatusTimer);
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.abortFetch();
      }

      onCompatibleAccessoryControl(event) {
        const control = event.target.closest(
          "[data-ubpet-accessory-action], [data-ubpet-accessory-index]",
        );
        if (!control || !this.contains(control)) return;

        const carousel = control.closest(".ubpet-compatible-accessories");
        const list = carousel?.querySelector("[data-ubpet-accessory-list]");
        if (!list) return;

        const items = Array.from(
          list.querySelectorAll(".ubpet-compatible-accessories__item"),
        );
        if (items.length < 2) return;

        event.preventDefault();
        const currentIndex = this.getCompatibleAccessoryIndex(list, items);
        const action = control.dataset.ubpetAccessoryAction;
        let targetIndex = Number.parseInt(
          control.dataset.ubpetAccessoryIndex,
          10,
        );

        if (action === "previous") targetIndex = currentIndex - 1;
        if (action === "next") targetIndex = currentIndex + 1;
        if (!Number.isInteger(targetIndex)) return;
        targetIndex = Math.max(0, Math.min(items.length - 1, targetIndex));

        const listRect = list.getBoundingClientRect();
        const itemRect = items[targetIndex].getBoundingClientRect();
        const targetLeft = list.scrollLeft + itemRect.left - listRect.left;
        const reducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        ).matches;

        list.scrollTo({
          left: targetLeft,
          behavior: reducedMotion ? "auto" : "smooth",
        });
      }

      onCompatibleAccessoryScroll(event) {
        const list = event.target.closest?.("[data-ubpet-accessory-list]");
        if (!list || !this.contains(list)) return;

        if (this.compatibleAccessoryScrollFrame) {
          cancelAnimationFrame(this.compatibleAccessoryScrollFrame);
        }

        this.compatibleAccessoryScrollFrame = requestAnimationFrame(() => {
          this.updateCompatibleAccessoryControls(list);
          this.compatibleAccessoryScrollFrame = null;
        });
      }

      getCompatibleAccessoryIndex(list, items) {
        const listLeft = list.getBoundingClientRect().left;
        let currentIndex = 0;
        let shortestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - listLeft);
          if (distance < shortestDistance) {
            shortestDistance = distance;
            currentIndex = index;
          }
        });

        return currentIndex;
      }

      updateCompatibleAccessoryControls(list) {
        const carousel = list.closest(".ubpet-compatible-accessories");
        const controls = carousel?.querySelector(
          "[data-ubpet-accessory-controls]",
        );
        if (!controls) return;

        const items = Array.from(
          list.querySelectorAll(".ubpet-compatible-accessories__item"),
        );
        if (items.length < 2) {
          controls.hidden = true;
          return;
        }

        controls.hidden = false;
        const currentIndex = this.getCompatibleAccessoryIndex(list, items);
        const previous = controls.querySelector(
          '[data-ubpet-accessory-action="previous"]',
        );
        const next = controls.querySelector(
          '[data-ubpet-accessory-action="next"]',
        );

        if (previous) previous.disabled = currentIndex === 0;
        if (next) next.disabled = currentIndex === items.length - 1;

        controls
          .querySelectorAll("[data-ubpet-accessory-index]")
          .forEach((dot, index) => {
            if (index === currentIndex) {
              dot.setAttribute("aria-current", "true");
            } else {
              dot.removeAttribute("aria-current");
            }
          });

        const status = controls.querySelector("[data-ubpet-accessory-status]");
        if (status) {
          const heading = carousel
            .querySelector(".ubpet-compatible-accessories__heading")
            ?.textContent.trim();

          clearTimeout(this.compatibleAccessoryStatusTimer);
          this.compatibleAccessoryStatusTimer = setTimeout(() => {
            status.textContent = `${heading ? `${heading} ` : ""}${currentIndex + 1} / ${items.length}`;
          }, 140);
        }
      }
    },
  );
}
